module.exports = __webpack_public_path__ + "img/Group_27905.cfc7b721.svg";